// "Offenes Ende": an end date past the planning horizon means the period has no last day.
// Mirrors Task.open_end_date? (BusinessDaysCalculator::MAX_PLANNING_HORIZON_YEARS), which the
// Plantafel uses to keep such an end when a bar is moved — the client must agree with it, or a
// resize looks saved while the server quietly keeps the old end.
const PLANNING_HORIZON_YEARS = 10

export function isOpenEndDate(isoDate, today = new Date()) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoDate || ""))
  if (!match) return false

  const horizon = `${today.getFullYear() + PLANNING_HORIZON_YEARS}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`
  return match[0] > horizon
}
